import styled from 'styled-components';

const Separator = styled.div`
  border-right: 1px solid ${({ theme }) => theme.colors.platinum};
  margin: ${({ theme }) => theme.spacing(0, 6)};
  height: auto;
`;

export default Separator;
